import { atom } from "jotai";

// ----------------------------
// Window Size State (with listener)
// ----------------------------
export const windowSizeState = atom({
  width: typeof window !== "undefined" ? window.innerWidth : 0,
  height: typeof window !== "undefined" ? window.innerHeight : 0,
});

// Attach resize listener when the atom is first used
windowSizeState.onMount = (set) => {
  const listener = () =>
    set({
      width: window.innerWidth,
      height: window.innerHeight,
    });

  window.addEventListener("resize", listener);
  return () => window.removeEventListener("resize", listener);
};

// ----------------------------
// Simple Boolean State
// ----------------------------
export const soundState = atom(false);

// ----------------------------
// Details Form State
// ----------------------------
export const detailsFormState = atom({
  animal: "",
  lastName: "",
  name: "",
  photography: false,
  range: true,
  stalking: true,
  phone: "",
  email: "",
  bushWalking: false,
  helicopters: false,
  bowHunting: false,
  message: "",
});

// ----------------------------
// Current Hunt State
// ----------------------------
export const currentHuntState = atom({
  chamois: 0,
  thar: 0,
  goat: 0,
  fallow: 0,
  awaparaRam: 0,
  redStag: 0,
  extraDay: 0,
  330: 0,
  351: 0,
  381: 0,
  401: 0,
  431: 0,
  451: 0,
  481: 0,
  501: 0,
  521: 0,
  551: 0,
});

// ----------------------------
// Prices Array State
// ----------------------------
export const pricesState = atom<any[]>([]);
